// extracted by mini-css-extract-plugin
module.exports = {"block":"ChildrenBlocksContent_block__3mv9o","visible":"ChildrenBlocksContent_visible__3et-7","onlyDetails":"ChildrenBlocksContent_onlyDetails__1hAyq"};